import { apiCall } from "./Interceptor";

const CHAT_NOTIFICATION = "/chat/notification";
const GET_CAPACITY_NAMES_CHAT = "/chat/accepted/capacities";
const GET_BANKING_NAMES_CHAT = "/chat/accepted/bankingNames";

const sendChatNotification = async (data) => {
    const response = await apiCall.post(CHAT_NOTIFICATION,data);
    return response;
}
const getAllChatAcceptedCapacities = async (id,role) => {
    const response = await apiCall.get(`${GET_CAPACITY_NAMES_CHAT}?capacityId=${id}&specificationType=${role}`);
    return response;
}

const getAllChatAcceptedBankingListing = async (id) => {
    const response = await apiCall.get(`${GET_BANKING_NAMES_CHAT}?listingId=${id}`);
    return response;
}
export default {
    sendChatNotification,
    getAllChatAcceptedCapacities,
    getAllChatAcceptedBankingListing,
};
